
<div class="popup-createRoom">
  <div class="popup-createRoom-container">
    <div v-if="mainStep !== 'add-table'" class="nav-toggle" @click="closePopup">
      <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
    </div>
    <el-popover placement="right" width="200" v-model="quitAddTable" popper-class="popup-delete black-inputs">
      <p>Êtes vous sûr de vouloir quitter sans valider cette table ?</p>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" class="dark" type="primary" @click="quitAddTable = false">Annuler</el-button>
        <el-button type="primary" size="mini" @click="cancelAddTable">Confirmer</el-button>
      </div>
      <div v-if="mainStep === 'add-table'" slot="reference" class="nav-toggle" @click="closePopup">
        <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
      </div>
    </el-popover>
    <div class="popup-createRoom-rooms black-inputs" v-if="mainStep === 'create-rooms'">
      <div v-if="getRoomsDatas !== null">
        <div class="popup-createRoom-title">Editer une salle :</div>
        <draggable @end="sortTab">
          <div class="popup-createRoom-btn" v-for="r in orderedRoom" :key="r.name" :id="r.id">
            <el-button class="dark w80" @click="editRoom(r.id)">{{ r.name }}</el-button>
            <el-popover placement="right" width="200" v-model="popupDeleteRoom[r.id]"
              popper-class="popup-delete black-inputs">
              <p>Si vous voulez supprimer cette salle, merci d'indiquer votre mot de passe</p>
              <el-input v-model="checkPassValue" type="password"></el-input>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" class="dark" type="primary"
                  @click="popupDeleteRoom[r.id] = false">Annuler</el-button>
                <el-button type="primary" size="mini" @click="checkBeforeDelete(r)">Confirmer</el-button>
              </div>
              <el-button class="dark" slot="reference" type="info" icon="el-icon-close" circle></el-button>
            </el-popover>
          </div>
        </draggable>
      </div>
      <div class="popup-createRoom-title">Ajouter une salle :</div>
      <el-button class="dark" @click="subStep = 'create-room'" v-if="subStep !== 'create-room'">Ajouter une
        salle</el-button>
      <transition name="fade">
        <div v-if="subStep === 'create-room'">
          <el-form class="createRoom-form" ref="formNewRoom" :model="formNewRoom" label-width="0">
            <el-form-item>
              <el-input class="dark" v-model="formNewRoom.name" placeholder="Nom de la salle"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmitNewRoom">Valider</el-button>
            </el-form-item>
            <el-form-item>
              <el-button class="dark" type="primary" @click="cleanFormRoom">Annuler</el-button>
            </el-form-item>
          </el-form>
        </div>
      </transition>
      <div class="link" @click='showHideLockedRoom'>Définir des plages d’ouverture / fermeture</div>
    </div>
    <div class="popup-createRoom-room black-inputs" v-if="mainStep === 'edit-room'">
      <div class="popup-createRoom-title"
        v-if="getSelectedRoom !== '' && getRoomsDatas !== null && getRoomsDatas[getSelectedRoom] !== undefined">
        <div v-if="!editRoomName">
          <span class="popup-createRoom-title_text">{{ getRoomsDatas[getSelectedRoom].name }}</span>
          <el-button class="dark" icon="el-icon-edit" @click="editRoomNameOn" circle></el-button>
        </div>
        <div v-if="editRoomName">
          <span class="popup-createRoom-title_text">
            <el-input ref="editRoomNameInput" :placeholder="getRoomsDatas[getSelectedRoom].name"
              v-model="newRoomName"></el-input>
          </span>
          <el-button class="green" icon="el-icon-check" @click="editRoomNameValidate" circle></el-button>
        </div>
      </div>
      <div class="popup-createRoom-desc">Réalisez votre plan de table en déplaçant les tables créées à votre guise
      </div>
      <div class="popup-createRoom-desc">Cliquez sur une table pour la sélectionner</div>
      <el-button class="dark" @click="startNewTable">Ajouter une table</el-button>
    </div>
    <div v-if="editTable">
      <el-form class="createRoom-form black-inputs black-inputs_2" ref="formTable.data" :model="formTable.data"
        label-width="35%">
        <div class="black-inputs_2-container">
          <el-form-item label="Forme">
            <el-radio-group @change="updateTableForme({ data: formTable.data.style, id: formTable.data.id })"
              v-model="formTable.data.style">
              <el-radio-button class="rect" label="rect"></el-radio-button>
              <el-radio-button class="circle" label="circle"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Longueur" v-if="formTable.data.style === 'rect'">
            <el-input-number class="text-centered"
              @change="updateTableWidth({ data: formTable.data.width, id: formTable.data.id })" :min="1"
              v-model="formTable.data.width"></el-input-number>
          </el-form-item>
          <el-form-item label="Largeur" v-if="formTable.data.style === 'rect'">
            <el-input-number class="text-centered"
              @change="updateTableHeight({ data: formTable.data.height, id: formTable.data.id })" :min="1"
              v-model="formTable.data.height"></el-input-number>
          </el-form-item>
          <el-form-item label="Diamètre" v-if="formTable.data.style === 'circle'">
            <el-input-number class="text-centered"
              @change="updateTableDiameter({ data: formTable.data.width, id: formTable.data.id })" :min="1"
              v-model="formTable.data.width"></el-input-number>
          </el-form-item>
          <el-form-item label="Nb de places">
            <el-input-number class="text-centered"
              @change="updateTableNbCouvert({ data: formTable.data.nbCouvert, id: formTable.data.id })" :min="1"
              v-model="formTable.data.nbCouvert"></el-input-number>
          </el-form-item>
          <el-form-item label="Angle">
            <el-input-number class="text-centered" :min="0" :max="180" :step="45"
              @change="chooseAngle(formTable.data.angle, formTable.data.id)"
              v-model="formTable.data.angle"></el-input-number>
          </el-form-item>
          <el-form-item label="Numéro">
            <el-input-number class="text-centered" @change="updateTableId" @keyup.native="updateTableId" :min="1"
              v-model="formTable.data.id"></el-input-number>
          </el-form-item>
        </div>
        <el-form-item v-if="mainStep === 'add-table'">
          <el-button type="primary" @click="validNewTable">Valider</el-button>
        </el-form-item>
        <el-form-item v-if="mainStep === 'add-table'">
          <el-button class="dark" type="primary" @click="cancelAddTable">Annuler</el-button>
        </el-form-item>
        <el-form-item v-if="mainStep !== 'add-table'">
          <el-button class="dark" type="primary" @click="duplicateTable">Dupliquer</el-button>
        </el-form-item>
        <el-form-item v-if="mainStep !== 'add-table'">
          <el-popover placement="right" width="200" v-model="popupDeleteTable"
            popper-class="popup-delete black-inputs">
            <p>Voulez-vous supprimer cette table ?</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" class="dark" type="primary" @click="popupDeleteTable = false">Annuler</el-button>
              <el-button type="primary" size="mini" @click="removeSelectedTable">Confirmer</el-button>
            </div>
            <el-button slot="reference" class="dark" type="primary">Supprimer</el-button>
          </el-popover>
        </el-form-item>
      </el-form>
    </div>
  </div>
</div>
